import React from "react";
import {
  DataGrid,
  GridToolbarQuickFilter,
  GridLinkOperator,
  gridClasses,
} from "@mui/x-data-grid";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import dayjs from "dayjs";
import Config from "conFig.js";
const datagridSx = {
  [`& .${gridClasses.cell}`]: {
    py: 1,
  },
  [`& .center`]: {
    justifyContent: "center !important",
  },
  borderRadius: 2,
  "& .MuiDataGrid-main": { borderRadius: 2 },
  "& .MuiDataGrid-virtualScrollerRenderZone": {
    "& .MuiDataGrid-row": {
      "&:nth-of-type(2n)": { backgroundColor: "rgba(235, 235, 235, .7)" },
    },
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "rgba(0,0,255,0.6)",
    color: "rgb(255 255 255)",
    fontSize: 16,
  },
  "& .MuiInputBase-root": {
    height: "25px",
  },
};
const hdcolumn = [
  {
    field: "stt",
    headerName: "STT",
    width: 70,
    headerAlign: "center",
  },
  {
    field: "tendonvi",
    headerName: "Đơn vị",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "sohopdong",
    headerName: "Số hợp đồng",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ngayhopdong",
    headerName: "Ngày hợp đồng",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "ten_dvthue",
    headerName: "Đơn vị thuê",
    width: 180,
    headerAlign: "center",
  },
  {
    field: "diachi_dvthue",
    headerName: "Địa chỉ đơn vị thuê",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "mst_dvthue",
    headerName: "MST đơn vị thuê",
    width: 150,
    headerAlign: "center",
  },
  {
    field: "diadiem_dau",
    headerName: "Điểm đầu",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "diadiem_cuoi",
    headerName: "Điểm cuối",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "hanhtrinh",
    headerName: "Hành trình",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "diemdontrakhach",
    headerName: "Điểm đón, trả khách",
    width: 200,
    headerAlign: "center",
  },
  {
    field: "culy",
    headerName: "Cự ly (km)",
    width: 120,
    headerAlign: "center",
  },
  {
    field: "tg_donkhach",
    headerName: "Thời gian đón khách",
    width: 170,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("HH:mm DD/MM/YYYY"),
  },
  {
    field: "tg_trakhach",
    headerName: "Thời gian trả khách",
    width: 170,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("HH:mm DD/MM/YYYY"),
  },
  {
    field: "noidungkhac",
    headerName: "Nội dung khác",
    width: 170,
    headerAlign: "center",
  },
  {
    field: "xacnhan",
    headerName: "Xác nhận",
    width: 130,
    headerAlign: "center",
  },
  {
    field: "ngaycn",
    headerName: "Ngày cập nhật",
    width: 150,
    headerAlign: "center",
    valueFormatter: (params) => dayjs(params.value).format("HH:mm DD/MM/YYYY"),
  },
  {
    field: "nguoicn",
    headerName: "Người cập nhật",
    width: 150,
    headerAlign: "center",
  },
];

export default function Huyxacnhanhopdong() {
  const [pageSize, setPageSize] = React.useState(50);
  const [hopdong, setHopdong] = React.useState([]);
  const [idhopdong, setIdhopdong] = React.useState(0);
  const [disableBT, setDisableBT] = React.useState(true);
  const [alert, setAlert] = React.useState(false);
  const quickSearchToolbar = () => {
    return (
      <Box
        sx={{
          p: 0.5,
          pb: 0,
        }}
      >
        <GridToolbarQuickFilter
          quickFilterParser={(searchInput: string) =>
            searchInput
              .split(",")
              .map((value) => value.trim())
              .filter((value) => value !== "")
          }
          placeholder="Tìm kiếm"
        />
      </Box>
    );
  };
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const gethopdong = () => {
    var url =
      Config.backend +
      "/api/Phuongtien/gethopdongvttheottxacnhan?xacnhan=1&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHopdong(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const huyxacnhan = () => {
    var url = Config.backend + "/api/Phuongtien/huyxacnhanhopdongvt";
    fetch(url, {
      method: "PUT",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
      body: JSON.stringify({
        id: idhopdong,
        username: username,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data === 1) {
          gethopdong();
          showNotification();
        }
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 2000);
  };
  React.useEffect(() => {
    gethopdong();
  }, []);
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12}>
        <FormControl style={{ width: "15%", marginTop: 5 }}>
          <Button
            color="success"
            variant="contained"
            style={{ height: 27 }}
            disabled={disableBT}
            onClick={huyxacnhan}
          >
            Hủy xác nhận
          </Button>
        </FormControl>
      </GridItem>
      <GridItem xs={12} sm={10} md={12}>
        <div style={{ height: 500, width: "100%", marginTop: 10 }}>
          <DataGrid
            getRowId={(row) => row.stt}
            rows={hopdong}
            columns={hdcolumn}
            checkboxSelection={false}
            getRowHeight={() => "auto"}
            headerHeight={35}
            sx={datagridSx}
            pageSize={pageSize}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            rowsPerPageOptions={[20, 50, 100]}
            pagination
            initialState={{
              filter: {
                filterModel: {
                  items: [],
                  quickFilterLogicOperator: GridLinkOperator.Or,
                },
              },
            }}
            components={{ Toolbar: quickSearchToolbar }}
            onRowClick={(params) => {
              setDisableBT(false);
              setIdhopdong(Number(params.row.id));
            }}
          />
        </div>
      </GridItem>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Hủy xác nhận thành công"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </GridContainer>
  );
}
